import { QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

/**
 * Stale-time policy lives in each feature's query hook (per-query).
 * Defaults here are conservative — refetch on focus, retry once.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60, // 1h in cache after unmount
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

/**
 * Cross-session cache (localStorage) for read-mostly data: /me, connector list,
 * report templates. Bump `buster` on breaking schema changes to invalidate.
 */
export const queryPersister = createSyncStoragePersister({
  storage: typeof window === 'undefined' ? undefined : window.localStorage,
  key: 'wisdomx-orbis-query-cache',
  throttleTime: 1000,
});
